import React, { useRef, useState } from 'react';
import { Play } from 'lucide-react';
import { trackTrailer } from '../../utils/analytics';

export const TRAILER_SRC = '/media/bethcoin_trailer_lipsync.mp4?v=499';
export const TRAILER_POSTER = '/media/bethcoin_trailer_lipsync_poster.jpg';

export const TrailerPlayer = ({ testId }) => {
  const [failed, setFailed] = useState(false);
  const sent = useRef({});
  const once = (event) => {
    if (sent.current[event]) return;
    sent.current[event] = true;
    trackTrailer(event, testId);
  };
  if (failed) return null;
  return (
    <div className="relative rounded-2xl overflow-hidden border border-emerald-500/30 shadow-[0_0_60px_-15px_rgba(16,185,129,0.45)] bg-black" data-testid={testId}>
      <video
        controls
        playsInline
        preload="metadata"
        poster={TRAILER_POSTER}
        className="w-full aspect-video bg-black"
        onError={() => setFailed(true)}
        onPlay={() => once('play')}
        onEnded={() => once('complete')}
        data-testid={`${testId}-video`}
      >
        <source src={TRAILER_SRC} type="video/mp4" onError={() => setFailed(true)} />
      </video>
    </div>
  );
};

export const HeroTrailer = () => (
  <div className="max-w-4xl mx-auto mt-12 mb-4" data-testid="hero-trailer">
    <p className="flex items-center justify-center gap-2 text-emerald-400 text-xs uppercase tracking-[0.3em] mb-4">
      <Play className="w-3 h-3" /> Watch the trailer
    </p>
    <TrailerPlayer testId="hero-trailer-player" />
  </div>
);

export const TrailerSection = () => (
  <section className="py-20 px-4 bg-black" data-testid="trailer-section">
    <div className="max-w-6xl mx-auto grid md:grid-cols-5 gap-10 items-center">
      <div className="md:col-span-2 text-left">
        <p className="text-emerald-400 font-mono text-xs uppercase tracking-[0.3em] mb-3">Wake up</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">You are the banker now.</h2>
        <p className="text-slate-400 text-base">
          See how BETHCOIN lets you open a wallet, mint crypto checks and take control of your credit, in 37 seconds.
        </p>
      </div>
      <div className="md:col-span-3">
        <TrailerPlayer testId="section-trailer-player" />
      </div>
    </div>
  </section>
);
